// @flow
import {
  FETCH_SKUS,
  FETCH_SKUS_SUCCESS,
  FETCH_SKUS_ERROR,
  INITIATE_FETCH_SKUS,
  UPDATE_SKU_PURCHASE_COUNT,
  RESET_SKUS
} from "./types";
import type { Action, CartData } from "./types";

export const fetchSkus = (selectedPod: any, affiliateUrl?: string): Action => ({
  type: FETCH_SKUS,
  payload: {selectedPod, affiliateUrl}
});

export const initiateFetchSkus = (): Action => ({
  type: INITIATE_FETCH_SKUS
});

export const fetchSkusSuccess = (skuData: any): Action => ({
  type: FETCH_SKUS_SUCCESS,
  payload: skuData
});

export const fetchSkusError = (error: any): Action => ({
  type: FETCH_SKUS_ERROR,
  payload: error
});

export const updateSkuPurchareCount = (cartData: CartData): Action => ({
  type: UPDATE_SKU_PURCHASE_COUNT,
  payload: cartData
});

export const resetSkus = (): Action => ({
  type: RESET_SKUS,
});

